module.exports = __webpack_public_path__ + "img/qrCode.4324cc85.png";